<template>
  <div class="d-flex h-100 padding">
    <div class="d-flex flex h-100 block m-0">

      <div class="d-flex flex" id="content-body">
        <div class="d-flex flex-column flex" id="mail-list" data-plugin="mail">
          <div class="scroll-y p-3 h-100">
            <div v-if="showData == false || backupsLoading" class="h-100 d-flex justify-content-center align-items-center">
              <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
            </div>

            <b-table v-else striped hover :items="backupsList" :fields="list_fields">
              <template slot="created" slot-scope="data">
                <span class="title-column">{{ $moment(data.value).format('YYYY-MM-DD HH:mm:ss') }}</span>
              </template>

              <template slot="ended" slot-scope="data">
                <span v-if="data.value.length == 0" class="title-column">{{ $t('message.Backups.processing') }}</span>
                <span v-else class="title-column">{{ $t('message.Backups.ended', {ended: $moment(data.value).format('YYYY-MM-DD HH:mm:ss')})  }}</span>
              </template>

              <template slot="row-details" slot-scope="data">
                <b-card>
                  {{ $t('message.Backups.backupedCollections') }}:
                  <ul>
                    <li v-for="val in data.item.collections">{{ val }}</li>
                  </ul>
                </b-card>
              </template>

              <template slot="actions" slot-scope="data">
                <div class="action-button-container d-flex">

                  <button class="btn btn-sm btn-white i-con-h-a mr-2"
                      data-toggle="tooltip"
                      v-b-tooltip.hover
                      title="Anzeigen"
                      @click="data.toggleDetails">
                    <i class="i-con i-con-eye text-muted"><i></i></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
          <div v-if="backupsLoading === false" class="p-3 b-t mt-auto">
            <div class="d-flex align-items-center">
              <div class="flex d-flex flex-row">
                <button type="submit" class="btn btn-success" @click="createBackups">{{ $t('message.Backups.create') }} </button>
              </div>
              <div class="flex d-flex flex-row">
                <button type="submit" class="btn btn-primary" @click="downloadJSON">{{ $t('message.Backups.downloadJSON') }} </button>
              </div>
              <div class="flex d-flex flex-row">
                <a href="#" class="btn btn-xs white no-border pager-prev hide">
                  <i class="fa fa-angle-left"></i>
                </a>
                <div class="pagination pagination-xs">
                </div>
                <a href="#" class="btn btn-xs white no-border pager-next hide">
                  <i class="fa fa-angle-right"></i>
                </a>
              </div>

              <div>
                <span class="text-muted">{{ $t('message.total') }}:</span>
                <span id="count"> {{ backups.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CommaSeparatedSpan from '@/components/CommaSeparatedSpan/CommaSeparatedSpan';

  import {BACKUPS_REQUEST, BACKUPS_SUCCESS, BACKUPS_CREATE, BACKUPS_CREATE_JSON} from '@/store/actions/backups';

  export default {
    name: "BackupsList",

    components: {
      CommaSeparatedSpan
    },

    data() {
      return {
        showData: false,
        searchValue: null,
        categoryColors: [],
        catIdsFilter: null,
        list_fields: [
          'id',
          {
            key: 'created',
            label: 'Created',
            sortable: true
          },
          {
            key: 'ended',
            label: 'Status',
            sortable: true
          },
          'actions'
        ],
      }
    },

    mounted() {
      this.$store.dispatch(BACKUPS_REQUEST)
          .then(() => {
            this.showData = true;
          })
      // if (this.booksLoaded) {
      //   this.showData = true
      // } else {
      //   setTimeout(() => {
      //     this.showData = true
      //   }, 1500)
      // }
    },

    computed: {
      backupsList() {
        return JSON.parse(JSON.stringify(this.backups));
      }

    },

    methods: {
      createBackups() {
        this.$store.dispatch(BACKUPS_CREATE)
      },

      downloadJSON() {
        this.$store.dispatch(BACKUPS_CREATE_JSON)
      }
    }
  }
</script>

<style scoped>
  .title-column {
    font-weight: bold;
  }

  .badge-circle.active{
    background: red;
  }
</style>
